// Main entry point for the Custom Markup Extension
import "./styles/CustomMarkupExtension.css";
import { CustomMarkupExtension } from "./core/CustomMarkupExtension.js";
import { EXTENSION_CONFIG } from "./config/constants.js";

// Register the extension with the Autodesk Viewing Extension Manager
window.Autodesk.Viewing.theExtensionManager.registerExtension(
	EXTENSION_CONFIG.EXTENSION_ID,
	CustomMarkupExtension
);

// Export for module usage
export { CustomMarkupExtension };
export default CustomMarkupExtension;

// Also make available globally for backward compatibility
window.CustomMarkupExtension = CustomMarkupExtension;
